import { render } from "./HomeDesktop.vue?vue&type=template&id=aca008f8&scoped=true"
import script from "./HomeDesktop.vue?vue&type=script&lang=ts"
export * from "./HomeDesktop.vue?vue&type=script&lang=ts"

import "./HomeDesktop.vue?vue&type=style&index=0&id=aca008f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-aca008f8"

export default script